module.exports = __webpack_public_path__ + "static/media/Sketch0.8221416b.jpeg";